export default {
  debtReminders: {
    stopTracking: "Arrêter le suivi",
    stopTrackingHint: "Les envois continuent ; le délai de 3 jours reste applicable.",
    pending: "Envoi en cours",
    notification: "Notification",
    neverSent: "Jamais envoyé",
    debtCount: "Échéances",
    notificationHistory: "Notifications de relance",
    viewHistory: "Historique",
    cooldown: "Attendez 3 jours entre les envois",
    unknown: "Résultat incertain ; envoi bloqué pendant 3 jours",
    simulated: "Simulation : aucun e-mail envoyé",
    lastAttempt: "Dernière tentative",
    nextAllowed: "Prochain envoi autorisé",
    history: "Historique des relances (50 dernières tentatives)",
    noHistory: "Aucun envoi enregistré",
    operator: "Demandé par",
    chargeLink: "Voir l’échéance",
    status: {QUEUED: "Planifié",DELIVERED: "Distribué",READ: "Lu",CANCELLED: "Annulé",PREPARING: "Préparation",SENDING: "Envoi / attente de confirmation",ACCEPTED: "Accepté par le service e-mail",FAILED: "Échec confirmé",UNKNOWN: "Résultat incertain",SIMULATED: "Simulation"},
    help: "Sélectionnez les personnes pour envoyer un seul e-mail par débiteur avec toutes ses échéances impayées. Les liens nécessitent le paiement en ligne. Jusqu’à 100 personnes par envoi.",
    select: "Sélectionner",
    count: "Mouvements dus",
    result: "Résultat",
    send: "Envoyer un e-mail de relance",
    filterAll: "Filtrer tous les mouvements",
    missingEmail: "Aucun e-mail enregistré",
    sent: "E-mail envoyé",
    noDebt: "Aucune échéance impayée restante",
    failed: "Échec : vérifiez l’e-mail et la disponibilité des liens de paiement",
    busy: "Envoi déjà en cours",
    sendError: "Impossible de confirmer l’envoi. Vérifiez le résultat avant de réessayer.",
    retry: "Réessayer",
  },
	title: "Gestion financière",
	subtitle: "Gestion financière du temple",
	menu: {
		dashboard: "Tableau de bord",
		funds: "Fonds",
		movements: "Transactions",
		reports: "Clôture",
		integrations: "Intégrations",
	},
	categories: {
		title: "Catégories de fonds",
		newCategory: "Nouvelle catégorie",
		editCategory: "Modifier la catégorie",
		name: "Nom",
		fundsCount: "Fonds liés",
		searchPlaceholder: "Rechercher des catégories...",
		noCategories: "Aucune catégorie enregistrée",
		noCategoriesSubtext: "Créez des catégories pour organiser les fonds de votre temple",
		confirmDelete: "Êtes-vous sûr de vouloir supprimer la catégorie \"{name}\" ?",
		stats: {
			total: "Catégories",
		},
		validation: {
			nameRequired: "Le nom est obligatoire",
			nameMaxLength: "Le nom doit comporter au maximum 100 caractères",
		},
	},
	funds: {
		title: "Fonds",
		newFund: "Nouveau fonds",
		editFund: "Modifier le fonds",
		name: "Nom",
		category: "Catégorie",
		description: "Description",
		createCategoryLink: "Créer une catégorie de fonds",
		recurring: {
			label: "Activer les cotisations récurrentes",
			hint: "Permet de facturer par personne (cotisation, dîme) dans l'onglet Cotisations. Désactivé, le fonds ne reçoit que des revenus ponctuels.",
			disableNote: "Pour désactiver, le fonds ne doit avoir aucune cotisation active.",
		},
		isFeatured: "En vedette",
		color: "Couleur",
		isFeaturedHint: "Les fonds en vedette apparaissent en haut de la page avec un accès rapide",
		targetAmount: "Montant cible",
		deadline: "Date limite",
		isActive: "Actif",
		perpetual: "Perpétuel",
		goalBased: "Basé sur un objectif",
		committed: "Prévu",
		collected: "Collecté",
		transferred: "Transféré",
		expenses: "Dépenses",
		balance: "Solde",
		groupFlow: "Mouvement de la période",
		groupStatus: "Situation du fonds",
		period: "Période",
		periodAll: "Cumulé",
		windowMonthly: "par mois",
		accumulatedBalance: "Solde cumulé",
		windowAccumulated: "cumulé",
		subscribers: "Inscrits",
		noFunds: "Aucun fonds enregistré",
		noFundsSubtext: "Créez des fonds pour gérer les revenus du temple",
		searchPlaceholder: "Rechercher des fonds...",
		featuredFunds: "En vedette",
		allFunds: "Tous les fonds",
		filters: {
			category: "Catégorie",
			status: "Statut",
			active: "Actif",
			inactive: "Inactif",
			clearFilters: "Effacer les filtres",
		},
		stats: {
			total: "Fonds",
			active: "Actifs",
			featured: "En vedette",
			totalBalance: "Solde cumulé",
		},
		validation: {
			nameRequired: "Le nom est obligatoire",
			nameMaxLength: "Le nom doit comporter au maximum 150 caractères",
			categoryRequired: "La catégorie est obligatoire",
		},
	},
	fundTabs: {
		dashboard: "Tableau de bord",
		movements: "Mouvements",
		recorrencias: "Récurrences",
		expenses: "Dépenses",
	},
	income: {
		title: "Nouvelle recette",
		modeNow: "Maintenant",
		modeOpen: "En attente (à recevoir)",
		modeInstallment: "Échelonné",
		modeRecurring: "Récurrent",
		saved: "Recette enregistrée avec succès",
		collisionTitle: "Charge en attente trouvée",
		collisionText: "{name} a déjà {count} charge(s) en attente dans ce fonds et ce mois ({amount}). Que souhaitez-vous faire ?",
		settleIt: "Régler",
		createAnyway: "Créer une nouvelle recette",
	},
	sales: {
		title: "Entrées",
		newSale: "Nouvelle recette",
		description: "Description",
		descriptionHint: "De quoi il s'agit (ex. : don, cotisation extra, vente, tombola)",
		saleDate: "Date",
		personOptionalHint: "Optionnel — laissez vide pour une entrée non identifiée",
		saved: "Saisie enregistrée avec succès",
		searchPlaceholder: "Rechercher par description ou personne...",
		noSales: "Aucune entrée enregistrée",
		noSalesSubtext: "Enregistrez les entrées ponctuelles de ce fonds (dons, ventes, collectes)",
		totalThisView: "Total",
		modePaid: "Payé maintenant",
		modeOpen: "En attente (à recevoir)",
		filterAll: "Tous",
		filterOpen: "En attente",
		filterPaid: "Payés",
		totalOpen: "En attente",
		totalReceived: "Reçu",
	},
	charges: {
		title: "Cotisations",
		subscriptions: "Inscriptions",
		newCharge: "Créer une cotisation",
		batchCharge: "Cotisation groupée",
		batchChargeTitle: "Cotisation groupée",
		batchChargeCreated: "{count} cotisations créées",
		batchChargePartial: "{success} sur {total} cotisations créées",
		batchChargeAllFailed: "Impossible de créer les cotisations",
		person: "Personne",
		people: "Personnes",
		amount: "Montant",
		mode: "Mode",
		recurring: "Récurrent",
		oneTime: "Ponctuel",
		lumpSum: "Montant forfaitaire",
		lumpSumDesc: "Une seule charge sera créée.",
		recurringDesc: "Une charge sera créée chaque mois.",
		oneTimeDesc: "Une mensualité sera facturée chaque mois.",
		dueDay: "Jour d'échéance",
		dueDayHint: "Jour du mois pour la date d'échéance (1-28)",
		nextChargeHint: "Prochaine cotisation : générée le {generated}, échéance le {due}",
		installments: "Versements",
		firstImmediate: "Premier versement dû aujourd'hui",
		exempt: "Exempter",
		unexempt: "Retirer l'exemption",
		exemptReason: "Motif d'exemption",
		exemptNotes: "Notes (données sensibles)",
		deactivate: "Désactiver la cotisation",
		reactivate: "Réactiver",
		noCharges: "Aucune cotisation dans ce fonds",
		noChargesSubtext: "Créez des cotisations pour gérer les paiements",
		status: {
			active: "Active",
			exempt: "Exempté",
			inactive: "Inactive",
		},
		reasons: {
			FINANCIAL: "Financier",
			HEALTH: "Santé",
			SENIOR: "Senior",
			LEADERSHIP: "Direction",
			OTHER: "Autre",
		},
		editCharge: "Modifier la cotisation",
		editRecurrence: "Modifier la récurrence",
		history: "Historique",
		historyTitle: "Historique des modifications",
		noHistory: "Aucune modification enregistrée",
		historyFields: {
			amount: "Montant",
			dueDay: "Jour d'échéance",
			installments: "Versements",
		},
		searchPerson: "Rechercher une personne...",
		maxInstallmentsHint: "Maximum {n} versements (date limite du fonds : {date})",
		enrollExempt: "Créer comme exempté",
		viewRecurrences: "Récurrences",
		viewCalendar: "Calendrier",
		newOpenCharge: "Nouvelle cotisation en attente",
		chargeCreated: "Cotisation en attente créée",
		dueDate: "Échéance",
		personOpenHint: "Qui va régler cette cotisation",
		pay: "Régler",
		payCharge: "Régler",
		chargePaid: "Règlement enregistré",
		validation: {
			personRequired: "La personne est obligatoire",
			personsRequired: "Sélectionnez au moins une personne",
			amountRequired: "Le montant est obligatoire",
			installmentsRequired: "Le nombre de versements est obligatoire pour un paiement ponctuel",
			installmentsExceedDeadline: "Le nombre de versements dépasse la date limite du fonds ({date})",
			exemptReasonRequired: "Le motif d'exemption est obligatoire",
			descriptionRequired: "La description est obligatoire",
			dueDayRange: "Indiquez un jour entre 1 et 28",
			dueDateRequired: "La date d'échéance est obligatoire",
			dueDatePast: "La date d'échéance ne peut pas être dans le passé",
		},
	},
	movements: {
		reversedTrail: "Motif de l'annulation",
		title: "Mouvements",
		registerPayment: "Enregistrer un paiement",
		amount: "Montant",
		amountPaid: "Montant payé",
		method: "Méthode",
		referenceMonth: "Mois de référence",
		notes: "Notes",
		anonymous: "Anonyme",
		anonymousHint: "Laissez vide pour le mode anonyme",
		fund: "Fonds",
		amountBelowCommitted: "Attention : le montant est inférieur au montant prévu ({amount})",
		earlierMonthUnpaid: "Attention : il y a des mois antérieurs impayés",
		effectiveDate: "Date effective",
		cancel: "Annuler le paiement",
		confirmCancel: "Êtes-vous sûr de vouloir annuler ce paiement ?",
		reverse: "Contrepasser l’écriture",
		reverseShort: "Contrepasser",
		confirmReverse: "Contrepasser cette écriture ?",
		reversalReason: "Motif de contrepassation",
		reopenCharge: "Remettre la facturation en attente",
		reopenChargeHint: "La personne redevra ce mois-ci.",
		status: {
			PENDING: "En attente",
			PAID: "Payé",
			OVERDUE: "En retard",
			WAIVED: "Dispensé",
			CANCELLED: "Annulé",
			REVERSED: "Contrepassé",
			FORGIVEN: "Remis",
		},
		methods: {
			CASH: "Espèces",
			PIX: "PIX",
			TRANSFER: "Virement",
			OTHER: "Autre",
		},
		noMovements: "Aucun mouvement",
		attachment: "Reçu",
		attachmentHint: "Joindre une photo du reçu (optionnel)",
		residualForgiveWarning: "Le montant saisi est inférieur au montant facturé. La différence sera pardonnée — aucune charge supplémentaire ne sera générée.",
		residualCheckboxLabel: "Générer une charge pour le solde restant ({amount})",
		residualCheckboxHint: "Crée une nouvelle charge en attente pour que la personne paie plus tard. Si décoché, la différence est pardonnée.",
		residualAlwaysInfo: "Une charge pour le solde restant ({amount}) sera générée automatiquement.",
		forgivenReasonLabel: "Motif de la remise de {amount}",
		forgivenReasonHint: "Obligatoire : la maison renonce à ce montant, et la reddition de comptes doit en dire la raison.",
		partialSettleTrail: "Règlement partiel",
		chargedAmount: "Montant facturé",
		receivedAmount: "Montant reçu",
		forgivenAmount: "Remise accordée",
		residualAmount: "Solde restant",
		forgivenReasonTitle: "Motif de la remise",
		validation: {
			forgivenReasonRequired: "Indiquez le motif de la remise",
			amountRequired: "Le montant est obligatoire",
			methodRequired: "La méthode est obligatoire",
			referenceMonthRequired: "Le mois de référence est obligatoire",
			fundRequired: "Le fonds est obligatoire",
		},
	},
	movementFilters: {
		transfers: "Transferts",
		transferHint: "Les transferts figurent dans le total des transferts et le solde réalisé. Ils ne sont pas inclus dans Reçu ou Payé.",
		applyHint: "Choisissez une période puis cliquez sur Appliquer. Les étiquettes ci-dessous indiquent les filtres actifs.",
		period: "Période",
		dateBasis: "Date utilisée",
		type: "Type",
		situation: "Statut",
		from: "De",
		to: "À",
		apply: "Appliquer",
		invalidRange: "Saisissez une période valide dont le début précède ou égale la fin.",
		search: "Rechercher une personne, description ou code…",
		more: "Plus de filtres",
		method: "Moyen de paiement",
		minAmount: "Montant minimum",
		maxAmount: "Montant maximum",
		invalidAmounts: "Saisissez des montants valides avec un minimum inférieur ou égal au maximum.",
		all: "Tout l’historique",
		current: "Ce mois",
		previous: "Mois précédent",
		custom: "Personnalisée",
		reference: "Mois de référence",
		due: "Échéance",
		paid: "Paiement",
		quickOverdue: "Créances en retard",
		quickOverdueExpense: "Dettes en retard",
		quickDueSoon: "Échéance sous 7 jours",
		quickWeek: "À payer cette semaine",
		quickWeekIncome: "À recevoir cette semaine",
		quickToday: "Mouvementé aujourd'hui",
		quickPaid: "Payés ce mois",
	},
	movementsPage: {
		exportCsv: "Exporter CSV",
		printReport: "Imprimer",
		reportCount: "{count} sur {total} enregistrements correspondant aux filtres sélectionnés (limite : 2 000).",
		reportError: "Impossible de générer le rapport. Réessayez.",
		income: "Entrée",
		expense: "Sortie",
		title: "Transactions",
		subtitle: "Relevé général des revenus, dépenses et transferts",
		searchPerson: "Rechercher par personne...",
		allTypes: "Tous les types",
		allFunds: "Tous les fonds",
		allCategories: "Toutes les catégories",
		allStatuses: "Tous les statuts",
		typeIncome: "Revenu",
		typeExpense: "Dépense",
		typeTransfer: "Transfert",
		noMovements: "Aucune transaction trouvée",
		noMovementsSubtext: "Enregistrez des revenus, dépenses ou transferts pour consulter le relevé",
		type: "Type",
		clearFilters: "Effacer les filtres",
		dueWindow: "Échéance : {from} au {to}",
		totalsOfFilter: "Total du filtre :",
		totalReceived: "Encaissé",
		totalToReceive: "À encaisser",
		totalPaid: "Payé",
		totalToPay: "À payer",
		realizedBalance: "Solde réalisé",
		uncountedNotice: "Hors de ces totaux : {count} (annulé, résilié ou dispensé)",
		columns: {
			date: "Date",
			code: "Code",
			type: "Type",
			person: "Personne",
			fund: "Fonds",
			category: "Catégorie",
			referenceMonth: "Mois réf.",
			amount: "Montant",
			method: "Méthode",
			status: "Statut",
			description: "Description",
		},
		anonymous: "Anonyme",
	},
	grid: {
		title: "Contributions",
		member: "Membre",
		noData: "Aucune donnée à afficher",
		noDataSubtext: "Inscrivez des personnes dans ce fonds pour voir la grille",
		paymentDetail: "Détails du paiement",
		tooltipPaid: "Payé — cliquez pour les détails",
		tooltipPending: "En attente — cliquez pour enregistrer",
		tooltipOverdue: "En retard — cliquez pour enregistrer",
		tooltipWaived: "Dispensé",
		tooltipExempt: "Exempté",
		tooltipCancelled: "Annulé",
		tooltipReversed: "Contrepassé",
		tooltipSettledInMonth: "Réglée en {month} — la facture relève de cette période, l’argent est entré ce mois-là",
		tooltipForgivenInMonth: "Remise en {month} — la facture relève de cette période ; la maison y a renoncé ce mois-là",
		tooltipEmpty: "Aucun mouvement — cliquez pour enregistrer",
		avulsa: "Ponctuel",
		chargesTitle: "Factures",
		seeInMovements: "Voir les mouvements de cette personne",
		monthClosed: "Mois clôturé — impossible de créer des écritures",
		multipleCharges: "{count} factures ce mois-ci",
		newCharge: "Nouvelle facture",
		months: {
			"10": "Oct",
			"11": "Nov",
			"12": "Déc",
			"01": "Jan",
			"02": "Fév",
			"03": "Mar",
			"04": "Avr",
			"05": "Mai",
			"06": "Juin",
			"07": "Juil",
			"08": "Août",
			"09": "Sep",
		},
	},
	personFinancial: {
		title: "Financier",
		noHistory: "Aucun historique financier",
		noHistorySubtext: "Les paiements de cette personne apparaîtront ici",
		totalPaid: "Total payé",
		totalPending: "Total en attente",
		totalOverdue: "Total en retard",
		paidAt: "Payé le",
	},
	dashboard: {
		viewMovements: "Voir",
		delinquentHint: "Échéances impayées des personnes en retard, tous mois confondus. Le tableau de bord compte les personnes ; chaque ligne ici est une échéance.",
		monthlyCollected: "Collecte mensuelle",
		goalPercent: "Objectif atteint",
		remaining: "Restant",
		overdueCount: "En retard",
		featuredFunds: "Fonds en vedette",
		receivableTitle: "Comptes à Recevoir",
		payableTitle: "Comptes à Payer",
		bucket: {
			overdue: "Échues",
			dueIn7Days: "Échéance sous 7 jours",
			dueAfter7Days: "Échéance après 7 jours",
			open: "Total",
		},
		committed: "Prévu",
		collected: "Collecté",
		noFeatured: "Aucun fonds en vedette",
		delinquents: "Membres en retard",
		noDelinquents: "Aucun membre en retard",
		totalDue: "Total dû",
		monthsOverdue: "mois de retard",
		noChartData: "Aucune donnée pour afficher le graphique",
	},
	/**
	 * La soupape de caisse (ISSUE-034) : une facture d’un mois clôturé n’est jamais
	 * marquée payée sur ce mois — un reçu naît dans le mois ouvert, et le document
	 * déjà présenté en assemblée continue de dire ce qu’il disait.
	 */
	settlement: {
		valveNotice:
			"Le reçu entre dans {openMonth} ; la trésorerie de {originMonth}, déjà clôturé, reste inchangée.",
		valveNoticeByDueDate:
			"Le reçu entre dans {openMonth} ; la trésorerie de {closedMonth}, clôturé à l’échéance, reste inchangée.",
		integralOnly:
			"Mois clôturé : règlement intégral seulement. Pour une partie ou une remise, utilisez Remettre.",
		settledInMonth: "Réglée en {month}",
		settledInMonthHint: "La facture reste sur cette période ; l’argent est entré en {month}.",
		legendSettledInMonth: "Réglée sur un autre mois (période clôturée)",
		receiptOf: "Encaissement de la période {month}",
		forgivenInMonth: "Remis",
		forgivenInMonthHint: "Remise en {month} ; la période ne change pas.",
		forgivenPartialHint: "Reçu ; le reste a été remis",
		forgivenReason: "Motif de la remise",
		legendForgivenInMonth: "Remis",
		forgivenessOf: "Remise de la période {month}",
		forgivenessOfHint: "Facture d’origine #{code}, de {month}.",
		closedPeriodForgiveness: {
			title: "Remises de périodes clôturées",
			hint: "Détail par période d’origine. Déjà compté dans la Remise de créance.",
			column: "Période d’origine",
			received: "Reçu",
			forgiven: "Remis",
			full: "Intégrale",
			partial: "Partielle",
		},
		closedPeriodReceipts: {
			title: "Encaissements de périodes clôturées",
			hint: "Déjà inclus dans les recettes du mois. Les périodes d’origine conservent leur facture ouverte, comme l’indiquait le document de ce mois-là.",
			column: "Période d’origine",
		},
	},
	/** Remise d’une facture de mois clôturé (ISSUE-036) : une écriture de remise naît dans le mois ouvert ; le mois clôturé ne change pas. */
	forgiveness: {
		title: "Remettre une facture de mois clôturé",
		action: "Remettre",
		actionTooltip: "Remettre une facture de mois clôturé",
		insteadOfPaying: "Remettre au lieu de recevoir",
		notice:
			"{originMonth} est clôturé. La remise entre en {openMonth} ; {originMonth} ne change pas.",
		noticeByDueDate:
			"Échue en {closedMonth}, mois clôturé. La remise entre en {openMonth} ; {closedMonth} ne change pas.",
		reasonLabel: "Motif de la remise",
		reasonHint: "Consigné dans la reddition des comptes",
		reasonRequired: "Indiquez le motif de la remise",
		partialSwitch: "J’ai reçu une partie",
		amountLabel: "Montant reçu",
		amountInvalid: "Supérieur à zéro et inférieur au montant facturé",
		methodRequired: "Indiquez le mode",
		forgivenSummary: "Remis : {amount}",
		receivedSummary: "Reçu : {amount}",
		success: "Facture remise. Écriture en {month}.",
		confirm: "Remettre",
	},
	report: {
		title: "Rapport",
		totalCollected: "Total collecté",
		totalCommitted: "Total prévu",
		adherence: "Adhésion",
		adherenceNoBase: "aucun mois clos avec appels",
		chargesActive: "Appels actifs",
		allMovements: "Mouvements",
		registeredBy: "Enregistré par",
		timeProgress: "Progression temporelle",
		elapsed: "Écoulé",
		remaining: "Restant",
		chartTitle: "Collecte mensuelle",
		noChartData: "Aucune donnée pour afficher le graphique",
		searchPerson: "Rechercher une personne...",
	},
	insights: {
		analysisTitle: "Analyse de la période",
		periodAll: "Tout l’historique",
		periodLast6: "6 derniers mois",
		periodLast12: "12 derniers mois",
		periodCustom: "Période personnalisée",
		startMonth: "De",
		endMonth: "À",
		applyPeriod: "Appliquer",
		invalidRange: "Le mois de début doit précéder ou être égal au mois de fin.",
		appliedPeriod: "Période affichée",
		periodScope: "s’applique aux indicateurs et graphiques ci-dessous",
		pendingTitle: "Créances actuelles",
		pendingHint: "Situation actuelle, tous mois confondus. Cette section est indépendante du filtre de période.",
		flowHint: "Entrées et sorties payées par mois de référence, transferts inclus. Comparez les montants pour comprendre la variation du solde.",
		prevRealHint: "Montant prévu des créances liées aux inscriptions et montant déjà payé pour chaque mois de référence. Le mois actuel est encore en cours.",
		adherenceHint: "Pourcentage du montant prévu des créances liées aux inscriptions déjà payé. Les mois sans prévision n’ont pas de point ; le mois actuel peut encore évoluer.",
		agingHint: "Montants restant dus de tous les mois, regroupés par jours de retard. «À jour» inclut les créances non échues ou sans date d’échéance.",
		topDebtorsHint: "Les cinq personnes ayant les montants restant dus les plus élevés, tous mois confondus, y compris les créances non échues.",
		methodHint: "Répartition des recettes payées par moyen de paiement pour les mois de référence affichés, hors transferts entre fonds.",
		categoryHint: "Répartition des dépenses payées et classées par catégorie sur la période affichée. Les dépenses sans catégorie sont exclues du graphique.",
		balanceEvolutionTitle: "Évolution du solde du fonds",
		balanceEvolutionHint: "Solde par mois de référence, transferts inclus. Les paiements des mois futurs apparaissent dans le mois correspondant. Mois actuel en cours.",
		zeroBalance: "Solde nul",
		currentPosition: "Situation actuelle · tous les mois",
		adherenceTitle: "Adhésion mensuelle",
		agingTitle: "Impayés par ancienneté",
		flowTitle: "Entrées et sorties",
		methodTitle: "Reçu par méthode",
		open: "En attente",
		balance: "Solde",
		income: "Entrées",
		expense: "Sorties",
		agingCurrent: "À jour",
		aging1_30: "1–30 jours",
		aging31_60: "31–60 jours",
		aging60plus: "60+ jours",
		noData: "Aucune donnée à afficher",
		noOpen: "Aucune cotisation en attente",
		prevRealTitle: "Prévu vs. réalisé",
		expected: "Prévu",
		received: "Reçu",
		topDebtorsTitle: "Principaux débiteurs",
		cumulativeTitle: "Solde cumulé",
		categoryTitle: "Dépenses par catégorie",
	},
	settings: {
		title: "Paramètres",
	},
	expenseCategories: {
		title: "Catégories de dépenses",
		newCategory: "Nouvelle catégorie",
		editCategory: "Modifier la catégorie",
		searchPlaceholder: "Rechercher une catégorie...",
		noCategories: "Aucune catégorie de dépenses",
		noCategoriesSubtext: "Créez des catégories pour classer les dépenses du temple",
		movementsCount: "mouvements",
		confirmDelete: "Êtes-vous sûr de vouloir supprimer \"{name}\" ?",
		stats: {
			total: "Total",
		},
	},
	expenses: {
		registerExpense: "Enregistrer une dépense",
		category: "Catégorie de dépense",
		fromFund: "À partir de quel fonds",
		description: "Description",
		descriptionPlaceholder: "Ex. : Facture d'électricité février, 10 kg de riz...",
		register: "Enregistrer",
		validation: {
			categoryRequired: "La catégorie est obligatoire",
		},
		scheduleExpense: "Planifier une dépense",
		payNow: "Payer maintenant",
		scheduleLater: "Planifier",
		recurring: "Récurrente",
		dueDate: "Date d'échéance",
		dueDateRequired: "La date d'échéance est obligatoire pour les dépenses planifiées",
		scheduledSuccess: "Dépense planifiée avec succès",
		payExpense: "Payer la dépense",
		expensePaid: "Dépense payée avec succès",
		methodRequiredForPayment: "Le mode de paiement est obligatoire",
	},
	recurringExpenses: {
		title: "Dépenses Récurrentes",
		newExpense: "Nouvelle Dépense Récurrente",
		editExpense: "Modifier Dépense Récurrente",
		name: "Nom",
		namePlaceholder: "Ex. : Loyer, Facture d'électricité...",
		category: "Catégorie",
		fund: "Fonds de sortie",
		dueDay: "Jour d'échéance",
		dueDayHint: "Jour du mois (1-28)",
		expectedAmount: "Montant prévu",
		isFixed: "Montant fixe",
		isVariable: "Montant variable",
		fixedHint: "Le montant est toujours le même chaque mois",
		variableHint: "Le montant peut varier chaque mois (ex. : facture d'électricité)",
		startDate: "Date de début",
		endDate: "Date de fin",
		endDateHint: "Laissez vide pour une récurrence indéfinie",
		active: "Active",
		inactive: "Inactive",
		deactivate: "Désactiver",
		activate: "Activer",
		editRecurring: "Modifier la récurrence",
		noExpenses: "Aucune dépense récurrente",
		noExpensesSubtext: "Enregistrez les dépenses mensuelles comme le loyer, l'électricité et l'internet",
		searchPlaceholder: "Rechercher des dépenses récurrentes...",
		generatedMovements: "Mouvements générés",
		validation: {
			nameRequired: "Le nom est obligatoire",
			categoryRequired: "La catégorie est obligatoire",
			fundRequired: "Le fonds est obligatoire",
			dueDayRequired: "Le jour d'échéance est obligatoire",
			amountRequired: "Le montant est obligatoire",
			startDateRequired: "La date de début est obligatoire",
		},
		messages: {
			created: "Dépense récurrente créée avec succès",
			updated: "Dépense récurrente mise à jour avec succès",
			deactivated: "Dépense récurrente désactivée",
			activated: "Dépense récurrente activée",
		},
	},
	transfers: {
		title: "Transfert",
		fromFund: "Fonds source",
		toFund: "Fonds de destination",
		description: "Description",
		descriptionPlaceholder: "Ex. : Transfert vers le fonds de fête...",
		transfer: "Transférer",
		balance: "Solde",
		negativeBalanceWarning: "Attention : ce transfert laissera le fonds source avec un solde négatif.",
		percentOfBalance: "Pourcentage du solde",
		validation: {
			fromFundRequired: "Le fonds source est obligatoire",
			toFundRequired: "Le fonds de destination est obligatoire",
			sameFund: "Les fonds source et de destination doivent être différents",
			percentRange: "Saisissez une valeur entre 1 % et 100 %",
		},
	},
	cashFlow: {
		totalBalance: "Solde total",
		monthIncome: "Revenus du mois",
		monthExpense: "Dépenses du mois",
		monthBalance: "Solde du mois",
		chartTitle: "Flux de trésorerie — Revenus vs Dépenses",
		income: "Revenus",
		expense: "Dépenses",
		balance: "Solde cumulé",
	},
	messages: {
		categoryCreated: "Catégorie créée avec succès",
		categoryUpdated: "Catégorie mise à jour avec succès",
		categoryDeleted: "Catégorie supprimée avec succès",
		expenseCategoryCreated: "Catégorie de dépense créée avec succès",
		expenseCategoryUpdated: "Catégorie de dépense mise à jour avec succès",
		expenseCategoryDeleted: "Catégorie de dépense supprimée avec succès",
		fundCreated: "Fonds créé avec succès",
		fundUpdated: "Fonds mis à jour avec succès",
		errorLoading: "Erreur lors du chargement des données financières",
		chargeCreated: "Cotisation créée avec succès",
		chargeExempted: "Exemption appliquée avec succès",
		chargeUnexempted: "Exemption retirée avec succès",
		chargeReactivated: "Cotisation réactivée avec succès",
		paymentRegistered: "Paiement enregistré avec succès",
		chargeUpdated: "Cotisation mise à jour avec succès",
		paymentCancelled: "Paiement annulé avec succès",
		paymentReversed: "Paiement contrepassé avec succès",
		expenseRegistered: "Dépense enregistrée avec succès",
		transferCompleted: "Transfert effectué avec succès",
		movementUpdated: "Mouvement mis à jour avec succès",
	},
	closing: {
		title: "Clôture mensuelle",
		subtitle: "Contrôle de clôture mensuelle et rapports",
		close: "Clôturer le mois",
		reopen: "Rouvrir le mois",
		confirmClose: "Êtes-vous sûr de vouloir clôturer le mois {month} ? Personne ne pourra créer, modifier ou contrepasser un mouvement de ce mois depuis le système.",
		confirmReopen: "Êtes-vous sûr de vouloir rouvrir le mois {month} ?",
		reopenLosesProof: "Rouvrir EFFACE le hash d'intégrité de ce mois : un rapport déjà imprimé ne peut plus être vérifié contre le système. La note écrite à la clôture sera également remplacée par celle que vous saisirez ci-dessous.",
		notes: "Notes",
		notesPlaceholder: "Motif de clôture/réouverture...",
		closingPreview: {
			heading: "En clôturant {month}, ceci reste en suspens :",
			charges: "{count} créance(s) à encaisser — {amount}",
			expenses: "{count} facture(s) à payer — {amount}",
			consequence: "Clôturer n'annule rien : la dette et la facture demeurent. Ce qui est encaissé ou payé plus tard est enregistré dans le mois ouvert où il est saisi, et les mouvements et les totaux de {month} ne changent pas.",
		},
		status: {
			OPEN: "Ouvert",
			CLOSED: "Clôturé",
		},
		report: {
			title: "Rapport mensuel",
			incomeByFund: "Revenus par fonds",
			expenseByCategory: "Dépenses par catégorie",
			byMethod: "Encaissements par méthode",
			delinquents: "Retardataires",
			comparison: "Comparaison avec le mois précédent",
			noData: "Aucune donnée pour ce mois",
			delta: "Variation",
			income: "Revenu",
			expense: "Dépense",
			balance: "Solde",
			total: "Total",
			previousMonth: "Mois précédent",
			openingBalance: "Solde d'ouverture",
			movementCount: "Mouvements",
			closedBy: "Clôturé par {user} le {date}",
			reopenedBy: "Rouvert par {user} le {date}",
			noNotes: "Aucune observation enregistrée.",
			previousClosings: "Clôtures précédentes de ce mois",
			previousClosingsHint: "Chaque réouverture met fin à la clôture précédente. Le code d'intégrité ci-dessous est celui imprimé sur les rapports de l'époque — il reste valable pour cette version, même si le mois a été clôturé à nouveau ensuite.",
			versionNumber: "Clôture {number}",
			supersededBy: "Rouvert par {user} le {date}",
			waived: "Dispensé",
			forgiven: "Remise accordée",
			closingBalance: "Solde de clôture",
		},
		partial: "Partiel",
		partialBanner: "Ce rapport est partiel — le mois est encore en cours.",
		closeSequential: "Clôturez le mois {month} avant de clôturer celui-ci.",
		isClosable: "Prêt pour la clôture",
		viewReport: "Voir le rapport",
		backToList: "Retour",
		recipients: {
			title: "E-mail de clôture mensuelle",
			description: "Envoyer le rapport par e-mail lors de la clôture du mois",
			admins: "Administrateurs",
			allUsers: "Tous les utilisateurs",
			corrente: "Membres actifs (corrente)",
		},
		messages: {
			monthClosed: "Mois clôturé avec succès",
			monthReopened: "Mois rouvert avec succès",
			error: "Erreur lors du traitement de la clôture",
		},
	},
	payment: {
		title: "Paiements en ligne",
		feeConfig: {
			title: "Enregistrement des frais Mercado Pago",
			description:
				"Mercado Pago prélève des frais par transaction (PIX 0,99 %, carte ~4,98 %) et les déduit avant que l'argent n'arrive sur le compte du temple — autrement dit, il entre moins que ce que le membre a payé. Pour que la reddition de comptes soit exacte, ORI conserve le paiement à son montant total et enregistre automatiquement cette différence comme une dépense « Frais Mercado Pago », liée à l'écriture d'origine. Ainsi, le solde du fonds reflète exactement le montant net réellement reçu.",
			example:
				"Exemple : le membre paie 50,00 R$ par PIX → le temple reçoit 49,50 R$ et ORI enregistre une dépense de 0,50 R$ (« Frais Mercado Pago - mov 260100 »). Le solde du fonds affiche les 49,50 R$ réellement encaissés.",
			enabledLabel: "Enregistrer les frais Mercado Pago comme dépense",
			fundSame: "Dans le même fonds qui a reçu le paiement",
			fundFixed: "Toujours dans un fonds spécifique",
			fundSelect: "Fonds de la dépense des frais",
			noFunds: "Aucun fonds enregistré",
			disableTitle: "Désactiver l'enregistrement des frais ?",
			disableWarning:
				"Nous recommandons vivement de garder cette option activée.\n\nSans l'enregistrement des frais, le solde de vos fonds sera surestimé : le système enregistre le montant total facturé au membre, mais le compte Mercado Pago du temple reçoit moins, car les frais ont déjà été prélevés. Votre reddition de comptes ne reflétera plus l'argent réellement encaissé.\n\nNe désactivez que si vous êtes pleinement conscient de cet écart et comptez rapprocher les frais manuellement.",
			disableConfirm: "Désactiver quand même",
			saveSuccess: "Configuration des frais enregistrée",
			saveError: "Échec de l'enregistrement de la configuration des frais",
		},
		autoDebitConfig: {
			enabledLabel: "Autoriser le prélèvement automatique (débit récurrent par carte)",
			description:
				"Lorsqu'il est activé, les membres peuvent autoriser le prélèvement automatique mensuel et vous pouvez l'activer sur les paiements. Désactivé, seul le PIX reste disponible — le bouton de prélèvement automatique n'apparaît plus. Les prélèvements automatiques déjà autorisés restent actifs et peuvent être suspendus ou annulés.",
			saveSuccess: "Préférence de prélèvement automatique enregistrée",
			saveError: "Échec de l'enregistrement de la préférence de prélèvement automatique",
		},
		consent: {
			title: "Avant de connecter Mercado Pago",
			intro:
				"En connectant votre compte, les paiements des membres seront traités par Mercado Pago. Avant de continuer, confirmez que vous comprenez que :",
			fees:
				"Mercado Pago prélève des frais par transaction (PIX 0,99 %, carte de crédit ~4,98 %), déduits automatiquement. ORI ne facture rien de plus.",
			netAmount:
				"Le montant déposé sur le compte du temple sera inférieur à celui payé par le membre, car les frais sont déduits avant le versement.",
			feeExpense:
				"ORI enregistre automatiquement ces frais comme une dépense « Frais Mercado Pago » dans les Finances, afin que le solde des fonds reflète le montant net reçu (ajustable dans les paramètres de l'intégration).",
			responsibility:
				"Les frais, les délais de versement et les politiques relèvent de la responsabilité de Mercado Pago, et non d'ORI. Vous êtes responsable du compte connecté et de la vérification des montants reçus.",
			checkbox: "J'ai lu et j'accepte les conditions ci-dessus.",
			confirm: "Connecter Mercado Pago",
		},
		connect: "Connecter Mercado Pago",
		disconnect: "Déconnecter",
		connected: "Connecté",
		connectedAs: "Compte : {account}",
		fees: "Frais Mercado Pago : PIX 0,99 % · carte ~4,98 % (~3,98 % après 30 jours). ORI ne prend rien de plus.",
		expired: "Expiré",
		revoked: "Déconnecté",
		notConnected: "Aucun compte de paiement connecté",
		moduleMissing:
			"ORI Paiements (intégration Mercado Pago) n'est pas inclus dans votre forfait. Ajoutez le module sur l'écran du forfait pour connecter.",
		connectRequired: "Connectez Mercado Pago dans Intégrations pour utiliser cette fonction",
		connectSuccess: "Compte de paiement connecté avec succès",
		connectError: "Échec de la connexion du compte de paiement",
		charge: {
			button: "Facturer en ligne",
			generating: "Génération de la facture...",
			copyLink: "Copier le lien",
			linkCopied: "Lien copié",
			created: "Facture créée",
			error: "Échec de la création de la facture",
			emailSent: "Envoyé par e-mail à",
		},
		mandate: {
			enable: "Prélèvement automatique",
			column: "Prélèvement automatique",
			manualBlocked:
				"Cette cotisation est en prélèvement automatique — Mercado Pago la débite automatiquement. Le paiement manuel n'est pas autorisé. Suspendez le prélèvement automatique pour encaisser autrement.",
			manualBlockedShort: "En prélèvement automatique — paiement manuel bloqué",
			pauseToPayManually: "Suspendre le prélèvement automatique",
			activate: "Activer le prélèvement automatique",
			resendLink: "Renvoyer le lien d'autorisation",
			pause: "Suspendre",
			resume: "Reprendre",
			cancel: "Annuler le prélèvement automatique",
			pausedSuccess: "Prélèvement automatique suspendu",
			resumedSuccess: "Prélèvement automatique repris",
			cancelledSuccess: "Prélèvement automatique annulé",
			authorizePrompt: "Activez le prélèvement automatique mensuel de cette cotisation.",
			confirmCancelTitle: "Annuler le prélèvement automatique ?",
			confirmCancelText:
				"Le prélèvement automatique mensuel cessera. Vous pourrez le réactiver plus tard.",
			state: {
				NONE: "Prélèvement automatique : désactivé",
				PENDING: "En attente d'autorisation du membre",
				AUTHORIZED: "Prélèvement automatique : actif",
				PAUSED: "Prélèvement automatique : suspendu",
			},
			tip: {
				NONE: "Prélèvement automatique désactivé. Activez-le pour que le membre autorise le débit mensuel.",
				PENDING: "En attente de l'autorisation du membre via le lien envoyé.",
				AUTHORIZED:
					"Prélèvement automatique actif — le membre est débité chaque mois. Suspendre l'interrompt sans l'annuler.",
				PAUSED: "Prélèvement automatique suspendu — les débits sont suspendus. Reprenez pour débiter à nouveau.",
			},
		},
		status: {
			PENDING: "En attente",
			AUTHORIZED: "Autorisé",
			PAUSED: "Suspendu",
			CANCELLED: "Annulé",
			PAID: "Payé",
			EXPIRED: "Expiré",
			FAILED: "Échoué",
		},
	},
	pay: {
		loading: "Chargement...",
		notFound: "Facture introuvable ou expirée",
		autoMandateTitle: "Fatigué de payer chaque mois ?",
		autoMandateText:
			"Activez le prélèvement automatique et ne payez plus manuellement — autorisez une fois et c'est tout.",
		enableAutoMandate: "Activer le prélèvement automatique",
		autoMandateError: "Impossible d'activer le prélèvement automatique. Réessayez.",
		title: "Paiement",
		amount: "Montant",
		temple: "Temple",
		month: "Mois",
		payWith: "Payer avec",
		pixTab: "PIX copier-coller",
		cardTab: "Carte",
		copyCode: "Copier le code PIX",
		codeCopied: "Code copié !",
		paid: "Paiement confirmé",
		expiredHint: "Le code PIX a une validité limitée. Générez-en un nouveau pour payer maintenant.",
		noPaymentDue: "Cette facture est clôturée. Aucun paiement n’est dû.",
		forgiven: "Facture remise par la maison. Rien à payer.",
		generateNewPix: "Générer un nouveau PIX",
		generateNewPixError: "Impossible de générer un nouveau PIX. Réessayez.",
		expired: "Cette facture a expiré",
		authorize: "Autoriser le prélèvement automatique",
		pixExpiryNotice: "Ce code PIX expire {time}. Ne programmez pas le paiement.",
		autoDebitUnavailable:
			"Le prélèvement automatique n'est plus disponible dans ce temple. Contactez l'administration pour convenir d'un autre moyen de paiement.",
	},
};
